export default "__VITE_ASSET__1cc6be94__"